<template>
  <v-dialog v-model="dialog" persistent eager max-width="300">
    <div class="edit-squadra">
      <v-card>
        <v-card-title class="navy white--text">
          <v-icon class="white--text" left>edit</v-icon>
          Modifica squadra
          <v-spacer></v-spacer>
          <v-btn depressed class="white--text" light icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="py-4 px-8">
          <v-form ref="form" v-model="valid">
            <v-row dense>
              <v-col cols="3">
                <div class="myPic" :class="myPicClass" @click="showPicDialog">
                  <label class="label">Logo</label>
                  <img v-if="myPic" :src="myPic" />
                </div>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  label="Nome squadra"
                  v-model="myNomeSquadra"
                  name="myNomeSquadra"
                  persistent-hint
                  required
                  outlined
                  class="mb-4"
                  counter
                  maxlength="50"
                  :rules="[rules.campoObbligatorio, rules.nomeTroppoLungo(50)]"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-btn
              rounded
              depressed
              large
              id="edit-squadra"
              class="secondary white--text"
              @click="save"
              :disabled="!valid"
              >Salva</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
      <v-dialog eager v-model="picDialog" max-width="700">
        <v-card class="navy darken-1">
          <v-card-title class="white--text">Scegli logo</v-card-title>
          <v-divider></v-divider>
          <div class="pics" :class="{ 'nice-scroll': !is_mobile }">
            <div
              v-for="(pic, index) in defaultPics"
              :key="index"
              class="pic navy darken-2"
              @click="saveMyPic(pic)"
            >
              <img :src="pic" />
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </v-dialog>
</template>

<script>
import Config from "../../../config-app/config";
import db from "../../js/db";
import toast from "../../js/toast";
import Vuex from "vuex";
import mixins from "../../js/mixins";

export default {
  name: "asta-edit-squadra",
  mixins: [mixins, toast],
  data() {
    return {
      dialog: false,
      picDialog: false,
      valid: false,
      myNomeSquadra: "",
      myPic: "",
      myPicClass: "",
      rules: {
        campoObbligatorio: (v) => !!v || "Campo obbligatorio",
        nomeTroppoLungo(nCharMax) {
          return (v) => (v || "").length <= nCharMax || "Nome troppo lungo";
        },
      },
    };
  },
  methods: {
    show() {
      this.myNomeSquadra = this.myNomeSquadraInitial;
      this.myPic = this.myPicInitial;
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
    showPicDialog() {
      this.myPicClass = "";
      this.picDialog = true;
    },
    saveMyPic(pic) {
      this.myPic = pic;
      this.picDialog = false;
    },
    save() {
      db.updateNomeSquadra(this.asta_id, this.user_uid, this.myNomeSquadra);
      db.updatePicSquadra(this.asta_id, this.user_uid, this.myPic);
      this.dismiss();
    },
  },
  computed: {
    myNomeSquadraInitial() {
      return this.asta_squadre[this.user_uid]
        ? this.asta_squadre[this.user_uid].name
        : "";
    },
    myPicInitial() {
      return this.asta_squadre[this.user_uid]
        ? this.asta_squadre[this.user_uid].pic
        : "";
    },
  },
  mounted() {
    console.log("--> AstaEditSquadra mounted.");
    db.on("showEditSquadra", this.show);
  },
  destroyed() {
    console.log("<-- AstaEditSquadra destroyed.");
    db.off("showEditSquadra", this.show);
  },
};
</script>

<style lang="scss" scoped>
@import "../../main.scss";

.edit-squadra {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  .ruoli {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  label,
  input,
  .v-messages__message,
  .v-input__icon {
    // color: white !important;
  }

  #edit-squadra.v-btn--disabled {
    background: rgb(255 255 255 / 33%) !important;
  }

  .myPic {
    border-radius: 4px;
    width: 56px;
    height: 56px;
    border: 1px solid hsla(0, 0%, 100%, 0.24);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    &.mancante {
      border: 2px solid var(--v-error-base);
      .label {
        color: var(--v-error-base) !important;
      }
    }
    &:not(.mancante):hover {
      // border-color: white;
    }
    .label {
      position: absolute;
      // color: rgba(255, 255, 255, 0.8) !important;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      font-size: 14px;
      line-height: 56px;
      cursor: pointer;
    }
    img {
      height: 95%;
      width: 95%;
      z-index: 1;
      position: relative;
      cursor: pointer;
      // background: #2e434c;
      border-radius: 2px;
    }
  }
}
.pics {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  padding: 10px;
  overflow-y: auto;
  max-height: 450px;
  .pic {
    height: 100px;
    width: 100px;
    border-radius: 4px;
    overflow: hidden;
    &:hover {
      opacity: 0.8;
    }
    img {
      cursor: pointer;
      border-radius: 4px;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
